(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/high-five-next-race/assets/javascripts/util.js') >= 0) return;  svs.modules.push('/components/racing/high-five-next-race/assets/javascripts/util.js');
"use strict";

const {
  buildLocationFromRace,
  locationToUrl
} = svs.isServer ? require('@svenskaspelab/trinidad-core').core.components.require('racing', 'race-navigation').location : svs.racing.navigation.location;
const {
  formatDate
} = svs.isServer ? require('@svenskaspelab/trinidad-core').core.components.require('lb-utils', 'helper-formatdate').api : svs.components.lbUtils.helpers.formatDate.formatDate;
const getPlayUrl = () => svs.isServer ? require('@svenskaspelab/trinidad-core').core.urlMapping.get('racing') : svs.core.urlMapping.get('racing');
const calculateTimeRemaining = countToString => {
  const now = new Date();
  const countTo = new Date(countToString);
  let minutes = Math.abs(Math.floor(dateFns.differenceInMinutes(countTo, now)) % 60).toString();
  let hours = Math.abs(Math.floor(dateFns.differenceInHours(countTo, now)) % 60).toString();
  let seconds = Math.abs(Math.floor(dateFns.differenceInSeconds(countTo, now)) % 60).toString();
  minutes = minutes.length < 2 ? "0".concat(minutes) : minutes;
  hours = hours.length < 2 ? "0".concat(hours) : hours;
  seconds = seconds.length < 2 ? "0".concat(seconds) : seconds;
  return {
    minutes,
    hours,
    seconds
  };
};
const createUrl = race => {
  const path = buildLocationFromRace(race);
  return "".concat(getPlayUrl()).concat(locationToUrl(path));
};
const formatRaceDate = date => formatDate(date, true, true);
if (svs.isServer) {
  module.exports = {
    calculateTimeRemaining,
    createUrl,
    formatRaceDate
  };
} else {
  svs.racing.high_five_next_race.util = {
    calculateTimeRemaining,
    createUrl,
    formatRaceDate
  };
}

 })(window);